import NavBar from "../components/navbar";
import Card from "../components/card";
import Footer from "../components/footer";
import { useNavigate } from "react-router-dom";

function Home() {
    let navigate = useNavigate();
    return (
        <div className="flex flex-col h-screen justify-between">
            <NavBar />
            <div className="text-3xl w-64 md:w-full flex flex-col md:flex-row justify-center self-center">
                <Card disabled name="agile_registration_link" title="Agile (Scrum Master)" url="https://docs.google.com/forms/d/1zfgWdHoXs-BzeKT3FSkmUKrcWKxSF6L3BkQv6G-tonI" image={require("../images/project.jpg")} text="Registration closed, Class starts September 10th!"/>
                <Card disabled name="aws_cp_registration_link" title="AWS Cloud Practitioner" url="https://docs.google.com/forms/d/11m9WTvn9ZGDh8Rw43ytxLr8xPBpgDJeNuMwJA6q6a0M" image={require("../images/cloud.jpg")} text="Registration closed, Class starts September 10th!"/>
                <Card disabled name="kids_coding_registration_link" title="Kids Coding Class" url="https://docs.google.com/forms/d/1jaZh35hM4BotkapJ5gOxkn9L5t8cmQrJ8ba6GAlKLdI" image={require("../images/kids.jpg")} text="Registration closed, Class starts September 10th!"/>
                <Card disabled name="cybersecurity_registration_link" title="Cybersecurity" url="https://docs.google.com/forms/d/11EpYylEIp0oLdBORUgV7bU-u7xLgs9mkJY7Pmme-3_g" image={require("../images/cyber.jpg")} text="Registration closed, Class starts September 10th!"/>
            </div>
            <div className="justify-center self-center">Prefer to self study? <span className="underline cursor-pointer" onClick={() => {navigate("../self_study")}}>Click here</span></div>
            <div className="justify-center self-center">Looking for a Job or Internship position? <span className="underline cursor-pointer" onClick={() => {navigate("../jobs_internship")}}>Click here</span></div>
            <Footer />
        </div>
    );
}

export default Home;
